const numberToWords = (num) => {
  const a = [
    "", "One", "Two", "Three", "Four", "Five", "Six",
    "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
    "Thirteen", "Fourteen", "Fifteen", "Sixteen",
    "Seventeen", "Eighteen", "Nineteen"
  ];
  const b = [
    "", "", "Twenty", "Thirty", "Forty", "Fifty",
    "Sixty", "Seventy", "Eighty", "Ninety"
  ];

  if (num === 0) return "Zero";

  // Split into rupees and paisa
  const rupees = Math.floor(num);
  const paisa = Math.round((num - rupees) * 100);

  const toWords = (n) => {
    let str = "";

    if (n >= 100) {
      str += a[Math.floor(n / 100)] + " Hundred";
      n %= 100;
      if (n > 0) str += " and ";
    }

    if (n >= 20) {
      str += b[Math.floor(n / 10)];
      if (n % 10 > 0) str += " " + a[n % 10];
    } else if (n > 0) {
      str += a[n];
    }

    return str.trim();
  };

  const convert = (n) => {
    let result = "";

    if (n >= 10000000) {
      result += toWords(Math.floor(n / 10000000)) + " Crore ";
      n %= 10000000;
    }

    if (n >= 100000) {
      result += toWords(Math.floor(n / 100000)) + " Lakh ";
      n %= 100000;
    }

    if (n >= 1000) {
      result += toWords(Math.floor(n / 1000)) + " Thousand ";
      n %= 1000;
    }

    if (n > 0) {
      result += toWords(n);
    }

    return result.trim();
  };

  let result = "";

  if (rupees > 0) {
    result += convert(rupees);
  }

  if (paisa > 0) {
    if (rupees > 0) result += " and ";
    result += convert(paisa) + " Paisa";
  }

  result += " Only";

  return result.trim();
};

export default numberToWords;
